module.exports = __webpack_public_path__ + "static/img/rob.f1b8cf0b.svg";